<app-engagement-hub-container
  [isUsingSecureLink]="true" 
  [onNavigateToNextEntity]="onNavigateToNextEntity()"
  [onNavigateToPreviousEntity]="onNavigateToPreviousEntity()"
  [onGoToStep]="onGoToStep()"
  [showSideDrawer]="showSideDrawer()"
  [initialView]="initialView()"
  (engagementHubView)="engagementHubView.emit($event)"
  (sideDrawerOpened)="sideDrawerOpened.emit($event)"
/>
